import { useTranslation } from "react-i18next"
import styles from "./ExampleSuggestions.module.scss"

type Example = {
    label: string
    value: string
}

interface Props {
    examples: Example[]
    onSelect: (value: string) => void
}

export default function ExampleSuggestions({ examples, onSelect }: Props) {
    const { t } = useTranslation("common")
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>{t("exampleSuggestions.title")}</h3>
            <div className={styles.list}>
                {examples.map(e => (
                    <button
                        key={e.value}
                        type="button"
                        className={styles.item}
                        onClick={() => onSelect(e.value)}
                    >
                        <span className={styles.jp}>{e.value}</span>
                        <span className={styles.romaji}>{t(`exampleSuggestions.labels.${e.value}`, { defaultValue: e.label })}</span>
                    </button>
                ))}
            </div>
        </div>
    )
}
